module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-28.18b63959.JPG";